import { ref as a, computed as e } from "vue";
const l = Object.freeze({
  key: Symbol("THUMBNAIL_INJECTION_KEY"),
  defaults: Object.freeze({
    radius: "rounded",
    draggable: e(() => !1),
    removable: e(() => !1),
    thumbnails: e(() => []),
    activeThumbnail: a(void 0),
    isDragging: a(!1)
  })
});
export {
  l as T
};
//# sourceMappingURL=ThumbnailGroup.keys-EJ4qFNhx.js.map
